



















































import Vue from 'vue';
import AppModule from '../../common/components/AppModule.vue';
import {AppModuleConfig, AppModuleNavItem} from '../../common/models/AppModuleConfig';
import customerClient from '../apis';
import appClient from '../../apis';
import moment from 'moment';
import commonVuex from '../../common/vuex/common';
import customerVuex from '../../customer/vuex/common';
import ModuleUpgrade from '../../common/components/ModuleUpgrade.vue';

const moduleNavs: AppModuleNavItem[] = [
  { name: '客户搜索', alias: 'search' },
  { name: '批量筛选', alias: 'filter' },
  { name: '标签管理', alias: 'remarks' },
  { name: '标签组', alias: 'remark-groups' },
  { name: '标签规则', alias: 'remark-rules' },
  { name: '客户字段设置', alias: 'fields' },
  { name: '数据导入', alias: 'import' },
  { name: '客户轨迹', alias: 'trace' },
];

const module: AppModuleConfig = {
  module: 'customer',
  name: '客户管理',
  navs: moduleNavs,
  description: undefined,
};

export default Vue.extend({
  mixins: [commonVuex, customerVuex],
  components: {
    AppModule,
    ModuleUpgrade,
  },
  data() {
    return {
      module,
      loading: false,
      syncStart: false,
      syncSuccess: false,
      syncStatus: null,
      upgradeStatus: null,
      hasRights: true,
      interval: null,
    };
  },
  computed: {
    lastSyncTime(): string {
      if (this.syncStatus &&
          this.syncStatus.endTime) {
        moment.locale('zh-cn');
        return moment(this.syncStatus.endTime).fromNow();
      } else {
        return '';
      }
    },
  },
  methods: {
    getRights() {
      appClient.hasRights({module: 'customer'}).success((r) => {
        this.hasRights = r;
      });
    },
    startSync() {
      if (!this.loading) {
        customerClient.syncCustomer({}).success(() => {
          this.loading = true;
          this.syncStart = true;
        }).failure((code: string, msg?: string) => {
          if (code === '2') {
            this.$Modal.warning({
              title: '同步频率过快，休息一会儿吧。',
              content: '每10分钟可最多手动触发一次同步。',
            });
          } else {
            this.$Message.warning(msg);
          }
        });
      }
    },
    listenCheckSync() {
      if (this.account) {
        appClient.getSyncStatus({}).success((r) => {
          const syncEnd = r.syncStatus && r.syncStatus.endTime;
          // 从水滴微信平台迁移已经完成
          this.syncStatus = r.syncStatus;
          if (syncEnd) {
            // 同步已经完成
            if (this.syncStart === true) {
              // 同步成功
              this.syncSuccess = true;
              this.$store.commit('CUSTOMER_TABLE_REFRESH');
            }
            this.loading = false;
            this.syncStart = false;
          } else if (r.syncStatus) {
            // 还在同步中
            this.loading = true;
            this.syncStart = true;
          } else {
            this.loading = false;
            this.syncStart = false;
          }

          if (r.firstSync && !syncEnd) {
            let percent = (r.firstSync.customerTotal / r.firstSync.followerTotal) * 100;
            percent = Math.round(percent < 99 ? percent : 99);
            this.$store.commit('UPDATE_DURING_FIRST_SYNC', {
              status: true,
              percent,
            });
          } else {
            this.$store.commit('UPDATE_DURING_FIRST_SYNC', {
              status: false,
              percent: 0,
            });
          }
        });
      }
    },
  },
  mounted() {
    this.listenCheckSync();
    this.getRights();
    this.interval = setInterval(() => {
      this.listenCheckSync();
      if (this.loading &&
          this.customerState.customerList.data &&
          this.customerState.customerList.data.length === 0) {
        this.$store.commit('CUSTOMER_TABLE_REFRESH');
      }
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
});
